export default __webpack_public_path__ + "static/media/townhall-icon.a773dfac.png";